angular.
module("dx.webapp.library").
directive("dxLibrary", function libraryDirective(
	DX_URLS
) {
	"use strict";

	return {
		restrict: "E",
		scope: {
			exam: "=",
			activeTab: "@",
			showLibrary: "=",
		},
		templateUrl: "tmpl/library/library-directive.html",
		controller: "DxLibraryController",
		controllerAs: "vm",
		replace: true,
		link: link,
	};

	function link(scope) {
		scope.Urls = DX_URLS;

		if (typeof scope.activeTab === "undefined") {
			scope.activeTab = "exams";
		}
	}
});
